module.exports = __webpack_public_path__ + "img/gm-bv.c47759c1.png";